import { useEffect, useState } from "react";
import { getTheme } from "../../theme";

export default function useTheme() {
  const [theme, setTheme] = useState(getTheme);
  useEffect(() => {
    const update = (event) => setTheme(event.detail);
    window.addEventListener("app-theme-change", update);
    // Covers a change between render and subscription.
    setTheme(getTheme());
    return () => window.removeEventListener("app-theme-change", update);
  }, []);
  return theme;
}
